// FUNCTIONS
const renderSliderInitial = () => {
	main.sync(thumbnails);

	main.mount();
	thumbnails.mount();

	main.on('move', function (newIndex, prevIndex, destIndex) {
		const index = String(newIndex + 1).padStart(2, '0');

		const copy = document.getElementById('splide02-slide' + index).dataset.copy;
		const heading = document.getElementById('splide02-slide' + index).dataset.heading;
		const link = document.getElementById('splide02-slide' + index).dataset.link;

		document.querySelector('.venues-slider-information .copy').innerHTML = copy;
		document.querySelector('.venues-slider-information .link a').href = link;
		document.querySelector('.venues-slider-information h4').textContent = heading;

		if (link && link.trim() !== '') {
			document.querySelector('.venues-slider-information .link a').style.display = '';
		} else {
			document.querySelector('.venues-slider-information .link a').style.display = 'none';
		}
	});
};

// VARIABLES
const main = new Splide('.venues-slider-main', {
	arrows: false,
	fixedHeight: '50rem',
	mediaQuery: 'max',
	pagination: false,
	rewind: true,
	type: 'fade',

	breakpoints: {
		767: {
			fixedHeight: '25rem'
		}
	}
});

const thumbnails = new Splide('.venues-slider-thumbnails', {
	arrows: false,
	fixedHeight: 60,
	fixedWidth: 100,
	focus: 'center',
	gap: 10,
	isNavigation: true,
	mediaQuery: 'max',
	pagination: false,
	rewind: true,

	breakpoints: {
		767: {
			fixedHeight: 44,
			fixedWidth: 60
		}
	}
});

// EVENT LISTENERS
document.addEventListener('DOMContentLoaded', () => {
	Fancybox.bind('[data-fancybox]', {});
	renderSliderInitial();
});